// extracted by mini-css-extract-plugin
export default {"InfoItem":"styles_InfoItem__uvMk-"};